import store from "@/store/index";
import router from "@/router/index";
// import { storage } from "@/utils/storage";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });
export const setTitle = (title) => {
  let { SystemName = "" } = window.appSetting || {};
  const conn = title && SystemName ? " - " : "";
  const docTitle = title + conn + SystemName;
  document.title = docTitle;
};
router.beforeEach(async (to, from, next) => {
  to.fullPath === from.fullPath && next(false); /* 重复路由禁止跳转 */
  NProgress.start();
  const { token, loginIdent } = store.getters; //user_id
  if (token && !loginIdent) await store.dispatch("user/fetchLoginUserInfo");
  next();
});
router.afterEach((to) => {
  const { title = "" } = to.meta;
  setTitle(title);
  NProgress.done();
});
